import axios from 'axios';
import { toQueryString } from '@/helpers/';

export const state = {
  assets: [],
  tranches: [],
  totalElements: 0,
  loading: false,
};

export const mutations = {
  CLEAR_DATA(context) {
    context.assets = [];
    context.tranches = [];
    context.currPage = 0;
    context.nextToken = null;
    context.totalElements = 0;
  },

  SET_ASSETS(context, assets) {
    assets.forEach((asset) => {
      const index = context.assets.findIndex(item => item.id === asset.id);

      if (index === -1) {
        // Element not found in the array, add it
        context.assets.push(asset);
      } else {
        // Element found in the array, update it
        context.assets[index] = asset;
      }
    });
  },
  SET_TRANCHES(context, tranches) {
    tranches.forEach((tranche) => {
      const index = context.tranches.findIndex(item => item.id === tranche.id);

      if (index === -1) {
        // Element not found in the array, add it
        context.tranches.push(tranche);
      } else {
        // Element found in the array, update it
        context.tranches[index] = tranche;
      }
    });
  },
  SET_PATCHED_ITEM(context, item) {
    // check if its an asset and update with new data
    const { assets, tranches } = context;
    let index = -1;

    index = assets.findIndex(el => item.id === el.id);
    if (index > -1) {
      assets[index] = { ...assets[index], ...item };
    }
    // check if its a tranche and update with new data
    index = tranches.findIndex(el => item.id === el.id);
    if (index > -1) {
      tranches[index] = { ...tranches[index], ...item };
    }

    context.assets = assets;
    context.tranches = tranches;
  },
  SET_LOADING(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async clearEIEAssetsData({ commit }) {
    commit('CLEAR_DATA');
  },
  async fetchEIEAssets({ commit, rootState }, params) {
    try {
      const options = {
        headers: {
          Authorization: rootState.userStore.user.signInUserSession.idToken.jwtToken,
        },
      };

      const query = toQueryString(params);


      commit('SET_LOADING', true);

      const URL = params.id ?
        `${window.BASE_API.EIE_ADMIN_BASE}/asset/${params.id}`
        : `${window.BASE_API.EIE_ADMIN_BASE}/assets?${query}`;

      const result = await axios.get(URL, options)
        .then(response => response.data);
      let assets = result.assets || [];
      let tranches = result.tranches || [];

      if (!result.assets) {
        assets = result.filter(item => !!item.securityIdType);
      }
      if (!result.tranches) {
        tranches = result.filter(item => !!item.financialProductId);
      }

      commit('SET_ASSETS', assets);
      commit('SET_TRANCHES', tranches);
    } catch (err) {
      console.error(err);
    }
    commit('SET_LOADING', false);
  },
  async patchEIEItem({ commit, rootState }, params) {
    try {
      const options = {
        headers: {
          Authorization: rootState.userStore.user.signInUserSession.idToken.jwtToken,
        },
      };

      const payload = {};
      if (params.isPublic) {
        payload.isPublic = params.isPublic;
      }
      if (params.isInvestable) {
        payload.isInvestable = params.isInvestable;
      }

      commit('SET_LOADING', true);

      const { data } = await axios.patch(`${window.BASE_API.EIE_ADMIN_BASE}/asset/${params.id}`, payload, options);
      delete data.message;

      commit('SET_PATCHED_ITEM', { id: params.id, ...data });
    } catch (err) {
      console.error(err);
    }
    commit('SET_LOADING', false);
  },
};

const eieAssetsStore = {
  state,
  mutations,
  actions,
};

export default eieAssetsStore;



// WEBPACK FOOTER //
// ./src/store/eieAssets/eieAssetsStore.js